module.exports = __webpack_public_path__ + "static/media/li.51c9d514.svg";